/**
 * YOUR SCORE, the phone's bottom sheet (DESIGN-CHANGELOG 2026-09-03 "Scores";
 * `design/GT Mobile Mine.dc.html`, the `scShow` block). AA phase 2.
 *
 * Header art · name · dev, then the eleven cells as a 6-column grid of 48px
 * targets — one tap sets AND closes — and a 44px footer with `✕ CLEAR MY
 * SCORE` when one is set. The note is the fact worth saying: THE PARTY SEES IT.
 */

import { CoverArt } from '../components/CoverArt.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useArt } from '../components/useArt.ts';
import { useQd } from '../store/index.ts';
import { scoreModalVM } from '../store/selectors.ts';

const MONO = 'var(--gt-font-mono)';

export default function ScoreSheet(): JSX.Element | null {
  const s = useQd();
  const v = scoreModalVM(s);
  const art = useArt((v?.id ?? 0) + 'w', v?.hdrCands ?? []);
  if (!v) return null;

  return (
    <Sheet
      onClose={() => s.closeScore()}
      label="Your score sheet"
      header={{ title: 'YOUR SCORE', titleClr: 'var(--gt-text)', titleFs: '9.5px', note: 'THE PARTY SEES IT' }}
    >
      <div style={{ display: 'flex', gap: 12, padding: '13px 14px', borderBottom: '1px solid var(--gt-line)' }}>
        <div
          style={{
            position: 'relative',
            width: 104,
            height: 49,
            flex: 'none',
            background: v.fall,
            overflow: 'hidden',
            border: '1px solid var(--gt-line)',
          }}
        >
          <CoverArt style={{ position: 'absolute', inset: 0 }} fs={9} ini={v.ini} hasCover={art.hasCover} cover={art.cover} />
        </div>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6, justifyContent: 'center' }}>
          <span
            style={{
              fontFamily: 'var(--gt-font-sans)',
              fontWeight: 600,
              fontSize: 14,
              color: 'var(--gt-text)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {v.name}
          </span>
          <span
            style={{
              fontFamily: MONO,
              fontSize: 8.5,
              letterSpacing: '.07em',
              color: 'var(--gt-faint)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {v.dev}
          </span>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 6, padding: 14 }}>
        {v.cells.map((c) => (
          <div
            key={c.key}
            onClick={() => void s.setScore(v.id, c.v)}
            style={{
              height: 48,
              boxSizing: 'border-box',
              border: '1px solid ' + c.bd,
              background: c.bg,
              color: c.fg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'var(--gt-font-pixel)',
              fontSize: 11,
              cursor: 'pointer',
            }}
          >
            <span style={{ transform: 'translateY(0.13em)' }}>{c.label}</span>
          </div>
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '12px 14px calc(14px + env(safe-area-inset-bottom))',
          borderTop: '1px solid var(--gt-line)',
          background: 'var(--gt-raised)',
        }}
      >
        {v.hasScore ? (
          <div
            onClick={() => void s.setScore(v.id, null)}
            style={{
              height: 44,
              display: 'flex',
              alignItems: 'center',
              padding: '0 12px',
              fontFamily: MONO,
              fontSize: '9.5px',
              letterSpacing: '.07em',
              color: 'var(--gt-text-5)',
              border: '1px solid var(--gt-border-2)',
              cursor: 'pointer',
              boxSizing: 'border-box',
            }}
          >
            ✕ CLEAR MY SCORE
          </div>
        ) : null}
        <div style={{ flex: 1 }} />
        <div
          onClick={() => s.closeScore()}
          style={{
            height: 44,
            display: 'flex',
            alignItems: 'center',
            padding: '0 14px',
            fontFamily: MONO,
            fontSize: 10,
            letterSpacing: '.07em',
            color: 'var(--gt-text-5)',
            border: '1px solid var(--gt-border-2)',
            cursor: 'pointer',
            boxSizing: 'border-box',
          }}
        >
          CANCEL
        </div>
      </div>
    </Sheet>
  );
}
